import axios from 'axios';
import { useQuery } from 'react-query';

// Commerce (merchant) users are approved via the same office endpoint as
// business users: PATCH /v1/office/user/business/approve?email=... There is
// no separate /office/merchant/verify route. Auth + email go in the request
// config (3rd arg).
const verifyMerchant = async (email: string) => {
  const { data } = await axios.patch(
    `${process.env.REACT_APP_API_URL}/office/user/business/approve`,
    {},
    {
      params: { email },
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    }
  );
  return data;
};

const useVerifyMerchant = (email: string, props = {}) =>
  useQuery(['verifyMerchant', { email }], () => verifyMerchant(email), {
    enabled: false,
    retry: false,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...props
  });

export default useVerifyMerchant;
